"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSignatureCanvas = _interopRequireDefault(require("react-signature-canvas"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Colors = require("../../constants/Colors");

var _underscore = _interopRequireDefault(require("underscore"));

var _SVGBuilder = _interopRequireWildcard(require("../../utils/SVGBuilder"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _InputField = _interopRequireDefault(require("../InputGrid/InputField"));

var _CheckBox = _interopRequireWildcard(require("../CheckBox/CheckBox"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FlexContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Signature__FlexContainer",
  componentId: "sf2dv1-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n"])));

var TextRow = /*#__PURE__*/(0, _styledComponents.default)(FlexContainer).withConfig({
  displayName: "Signature__TextRow",
  componentId: "sf2dv1-1"
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    margin-left: 5px;\n    margin-bottom: 10px;\n    > div {\n        margin-left: 3px;\n    }\n"])));
var CheckBoxRow = /*#__PURE__*/(0, _styledComponents.default)(FlexContainer).withConfig({
  displayName: "Signature__CheckBoxRow",
  componentId: "sf2dv1-2"
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-left: 15px;\n"])));
var StyleInputRow = /*#__PURE__*/(0, _styledComponents.default)(FlexContainer).withConfig({
  displayName: "Signature__StyleInputRow",
  componentId: "sf2dv1-3"
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    margin-bottom: 15px;\n    .input-field {\n        flex-grow: 1;\n    }\n    @media (min-width: 768px) {\n        > .input-field:not(:first-child) input {\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n        > .input-field:not(:last-child) input {\n            border-right: 0;\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n        }\n    }\n    @media (max-width: 767px) {\n        flex-direction: column;\n        align-items: stretch;\n        .form-group:not(:last-child) {\n            margin-bottom: 0;\n        }\n        > .input-field:not(:first-child) input {\n            border-top: 0;\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n        }\n        > .input-field:not(:last-child) input {\n            border-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n        }\n    }\n"])));

var SignatureContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Signature__SignatureContainer",
  componentId: "sf2dv1-4"
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    background: transparent;\n    padding: 5px;\n    color: ", ";\n"])), _Colors.emperor);

var SignatureCanvasDiv = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Signature__SignatureCanvasDiv",
  componentId: "sf2dv1-5"
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    margin-bottom: 15px;\n    border-radius: 5px;\n\n    background: ", " url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjx0ZXh0IHk9IjE1IiBzdHlsZT0iZmlsbDogIzU1NTU1NTsgZm9udDogYm9sZCAxNXB4IHNhbnMtc2VyaWY7Ij5YPC90ZXh0PjxsaW5lIHgxPSIyMCIgeTE9IjE1IiB4Mj0iMTAwJSIgeTI9IjE1IiBzdHJva2U9IiM1NTU1NTUiIC8+PC9zdmc+') center 93%/97% 16px no-repeat;\n"])), _Colors.white);

var ScreenReaderOnly = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "Signature__ScreenReaderOnly",
  componentId: "sf2dv1-6"
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n    display: none;\n    visibility: hidden;\n"])));

var ClearButton = /*#__PURE__*/(0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "Signature__ClearButton",
  componentId: "sf2dv1-7"
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n    margin-right: 0 !important;\n"])));

var Required = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "Signature__Required",
  componentId: "sf2dv1-8"
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: 26px;\n    line-height: 36px;\n    font-weight: 600;\n    color: ", ";\n    margin-right: 10px;\n"])), _Colors.thunderBird);

var LastSignature = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Signature__LastSignature",
  componentId: "sf2dv1-9"
})(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n    svg {\n        width: 100%;\n    }\n    .svg-signature-legal {\n        display: none;\n        visibility: hidden;\n    }\n"])));

var FIELD_LABELS = {
  firstName: 'First Name',
  middleName: 'Middle Name',
  lastName: 'Last Name'
};
var INITIAL_STATE = {
  value: undefined,
  firstName: undefined,
  middleName: undefined,
  lastName: undefined,
  valid: {
    firstName: false,
    middleName: true,
    lastName: false,
    checked: false
  }
};

var Signature = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Signature, _React$Component);

  var _super = _createSuper(Signature);

  function Signature(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Signature);
    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleResize = _underscore.default.throttle(_this.handleResize.bind((0, _assertThisInitialized2.default)(_this)), 300);
    var signed = props.value && window.atob(props.value).includes('svg-signature-box');
    _this.state = _objectSpread(_objectSpread({}, INITIAL_STATE), {}, {
      value: signed ? props.value : undefined //Only preload signature, if it is already signed

    });
    return _this;
  }

  (0, _createClass2.default)(Signature, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      this.handleResize();
      this.handleChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this$canvas;

      if ((_this$canvas = this.canvas) !== null && _this$canvas !== void 0 && _this$canvas.getCanvas) {
        var canvas = this.canvas.getCanvas();
        var value = this.canvas.isEmpty() ? null : new _SVGBuilder.default(this.canvas.toDataURL(_SVGBuilder.SVG_MIME));
        canvas.width = canvas.parentNode.clientWidth;
        canvas.height = canvas.width / this.props.heightRatio;

        if (value) {
          this.canvas.fromDataURL(value.attributes({
            width: canvas.parentNode.clientWidth
          }).dataUrl);
        }
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var signature = undefined,
          signedName = undefined;

      if (this.valid) {
        signature = this.signature;
        signedName = this.signedName;
      }

      this.props.onChange(this.valid, signature, signedName, this.signed);
    }
  }, {
    key: "fieldProps",
    value: function fieldProps(field) {
      var _this2 = this;

      var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var isValid = function isValid(val) {
        return !required || val !== '';
      };

      var props = {
        required: required,
        showValidationIcon: required,
        trim: true,
        labelAsPlaceHolder: true,
        label: FIELD_LABELS[field],
        name: field,
        value: this.state[field],
        onChange: function onChange(val) {
          var _this2$setState;

          return _this2.setState((_this2$setState = {}, (0, _defineProperty2.default)(_this2$setState, field, val || ''), (0, _defineProperty2.default)(_this2$setState, "valid", _objectSpread(_objectSpread({}, _this2.state.valid), {}, (0, _defineProperty2.default)({}, field, isValid(val)))), _this2$setState), _this2.handleChange);
        }
      };

      if (this.state[field]) {
        props.valid = isValid(this.state[field]);
      }

      return props;
    }
  }, {
    key: "reset",
    get: function get() {
      var _this3 = this;

      return function () {
        var _this3$canvas;

        var shouldResize = !!_this3.state.value;

        if ((_this3$canvas = _this3.canvas) !== null && _this3$canvas !== void 0 && _this3$canvas.clear) {
          _this3.canvas.clear();
        }

        _this3.setState(INITIAL_STATE, function () {
          if (shouldResize) _this3.handleResize();

          _this3.handleChange();
        });
      };
    }
  }, {
    key: "valid",
    get: function get() {
      return this.state.value && this.state.valid.checked || _underscore.default.reduce(this.state.valid, function (a, b) {
        return a && b;
      }, true);
    } //Return boolean indicating whether user has signed in signature box

  }, {
    key: "signed",
    get: function get() {
      var _this$canvas2;

      return !!this.state.value || !!this.canvas && !((_this$canvas2 = this.canvas) !== null && _this$canvas2 !== void 0 && _this$canvas2.isEmpty());
    }
  }, {
    key: "signedName",
    get: function get() {
      if (this.state.value) return new _SVGBuilder.default(this.lastSignature).extractText('.svg-signature-name .svg-bold');
      var middleName = (this.state.middleName || '') !== '' ? this.state.middleName + ' ' : '';
      return "".concat(this.state.firstName || '', " ").concat(middleName).concat(this.state.lastName || '');
    }
  }, {
    key: "lastSignature",
    get: function get() {
      return window.atob(this.state.value);
    }
  }, {
    key: "signature",
    get: function get() {
      if (this.state.value) return this.lastSignature; // this is how wide we want our image to be at 100% scale
      // this is a fixed value because we know the static text we add
      // fits within this width so we don't have to deal with text wrapping

      var width = 600; // these is the desired dimensions of the signature box
      // the width matches our desired width and the height depends
      // on the heightRatio prop

      var signatureSize = {
        width: width,
        height: width / this.props.heightRatio
      }; // this is the desired size of the overall image when scaled at 100%
      // really its gonna be the size of the signature plus a fixed value of
      // 60 to account for the text we are going to place under the box

      var imageSize = _objectSpread(_objectSpread({}, signatureSize), {}, {
        height: signatureSize.height + 60
      }); // create the outer svg...this is the main image


      var svgBuilder = new _SVGBuilder.default().attributes({
        viewBox: "0 0 ".concat(imageSize.width, " ").concat(imageSize.height),
        width: imageSize.width,
        height: imageSize.height
      }).css("\n            .svg-signature-border {\n                fill: ".concat(_Colors.gainsboro, ";\n                stroke-width: 1px;\n                stroke: ").concat(_Colors.alto, ";\n            }\n            .svg-signature-text {\n                font-family: Sans-Serif;\n                font-size: 16px;\n                fill: ").concat(_Colors.emperor, ";\n            }\n            .svg-no-signature-box {\n                font-size: 30px;\n                dominant-baseline: middle;\n                text-anchor: middle;\n            }\n            .svg-signature-legal {\n                font-size: 12px;\n            }\n            .svg-bold {\n                font-weight: 600;\n            }\n        ")).box({
        className: 'svg-signature-border',
        width: signatureSize.width,
        height: signatureSize.height
      });

      if (!this.canvas.isEmpty()) {
        var canvasParent = this.canvas.getCanvas().parentNode;
        var canvasSize = {
          width: canvasParent.clientWidth,
          height: canvasParent.clientHeight
        };
        svgBuilder.insertSvg(this.canvas.toDataURL(_SVGBuilder.SVG_MIME), {
          className: 'svg-signature-box',
          // use canvasSize in the viewBox to define the original size of the content
          viewBox: "0 0 ".concat(canvasSize.width, " ").concat(canvasSize.height),
          // then scale the it to match the signatureSize by setting a width and height
          width: signatureSize.width,
          height: signatureSize.height,
          // this will preserve the aspect ratio and put the signature in the middle of the box
          preserveAspectRatio: 'xMidYMid meet'
        });
      } else {
        svgBuilder.text('Digital Signature Image Was Not Provided', {
          className: 'svg-no-signature-box svg-signature-text',
          y: '35%',
          x: '50%'
        });
      }

      return svgBuilder.text([(0, _SVGBuilder.createTSpan)('Full name as signed above:  ', {
        className: 'svg-indented-text'
      }), (0, _SVGBuilder.createTSpan)(this.signedName, {
        className: 'svg-bold'
      })], {
        className: 'svg-signature-name svg-signature-text',
        x: 10,
        y: imageSize.height - 25
      }).text((0, _SVGBuilder.createTSpan)(this.props.consentText, {
        className: 'svg-indented-text'
      }), {
        className: 'svg-signature-legal svg-signature-text',
        x: 10,
        y: imageSize.height - 14
      }).svg;
    }
  }, {
    key: "renderSignatureCanvas",
    value: function renderSignatureCanvas() {
      var _this4 = this;

      var canvasProps = {
        onEnd: this.handleChange
      };
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(TextRow, null, /*#__PURE__*/_react.default.createElement("div", {
        "aria-hidden": "true"
      }, "Sign here with mouse or finger"), /*#__PURE__*/_react.default.createElement(ClearButton, {
        size: "small",
        type: "button",
        onClick: this.reset,
        className: "secondary hollow",
        "aria-label": "Clear Signature"
      }, "Clear Signature")), /*#__PURE__*/_react.default.createElement(SignatureCanvasDiv, {
        "aria-hidden": "true"
      }, /*#__PURE__*/_react.default.createElement(_reactSignatureCanvas.default, (0, _extends2.default)({
        onEnd: this.handleChange,
        ref: function ref(_ref) {
          _this4.canvas = _ref;
        }
      }, canvasProps))), /*#__PURE__*/_react.default.createElement(TextRow, null, /*#__PURE__*/_react.default.createElement(ScreenReaderOnly, null, "Type full name"), /*#__PURE__*/_react.default.createElement("div", {
        "aria-hidden": "true"
      }, "Type full name as signed above")), /*#__PURE__*/_react.default.createElement(StyleInputRow, null, /*#__PURE__*/_react.default.createElement(_InputField.default, this.fieldProps('firstName', true)), /*#__PURE__*/_react.default.createElement(_InputField.default, this.fieldProps('middleName')), /*#__PURE__*/_react.default.createElement(_InputField.default, this.fieldProps('lastName', true))));
    }
  }, {
    key: "renderLastSignature",
    value: function renderLastSignature() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(TextRow, null, /*#__PURE__*/_react.default.createElement("div", null, "Most Recent Signature Consent On File"), /*#__PURE__*/_react.default.createElement(ClearButton, {
        size: "small",
        type: "button",
        onClick: this.reset,
        className: "secondary hollow",
        "aria-label": "Clear & Sign Again"
      }, "Clear & Sign Again")), /*#__PURE__*/_react.default.createElement(LastSignature, {
        className: "last-signature-container",
        dangerouslySetInnerHTML: {
          __html: this.lastSignature
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/_react.default.createElement(SignatureContainer, null, this.state.value ? this.renderLastSignature() : this.renderSignatureCanvas(), /*#__PURE__*/_react.default.createElement(CheckBoxRow, null, /*#__PURE__*/_react.default.createElement(Required, null, "*"), /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
        checked: this.state.valid.checked,
        style: _CheckBox.STYLE_INVERTED_CHECKBOX,
        label: this.props.consentText,
        onChange: function onChange() {
          return _this5.setState({
            valid: _objectSpread(_objectSpread({}, _this5.state.valid), {}, {
              checked: !_this5.state.valid.checked
            })
          }, _this5.handleChange);
        }
      })));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        value: _propTypes.default.string,
        heightRatio: _propTypes.default.number,
        onChange: _propTypes.default.func,
        consentText: _propTypes.default.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        heightRatio: 4,
        onChange: function onChange() {},
        consentText: 'I consent to the disclosure of the credentials and any provided attachments \nto the delivery recipient, each as I\'ve selected above, and for the purpose identified by me above.'
      };
    }
  }]);
  return Signature;
}(_react.default.Component);

exports.default = Signature;